<template>
    <div class="">
        <v-card>
            <v-card-text>
                <v-row>
                    <v-col cols="11">
                        <v-card-title class="titulopagina">LISTADO DE PREEMBARQUES</v-card-title>
                    </v-col>
                    <v-col cols="1">
                        <v-alert class="amber accent-2 text-center" color="orange" outlined dense @click="abrirAyudas"><v-icon color="blue" large>help</v-icon></v-alert>
                    </v-col>
                </v-row>
            </v-card-text>
            <modal-ayuda></modal-ayuda>
        </v-card>
        <v-dialog
            v-model="abrir_modal"
            width="900"
        >

            <v-card>
                <v-card-title
                    class="headline indigo lighten-2"
                    primary-title
                    >
                    Detalle del Preembarque
                </v-card-title>

                <v-card-text>
                    <v-row>
                        <v-col >
                           <b>Bodega: </b> {{ preembarque.bodegas ? preembarque.bodegas.nombre : '' }}
                        </v-col>
                        <v-col >
                            <b>Preembarque: </b> {{ preembarque.nombre}}
                        </v-col>
                        <v-col >
                            <b>Fecha: </b> {{ preembarque.fecha}}
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col >
                            <b>Cliente: </b> {{ preembarque.clientes ? preembarque.clientes.nombre : ''}}
                        </v-col>
                        <v-col >
                            <b>Observaciones: </b> {{ preembarque.observaciones}}
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-divider></v-divider>
                <v-row>
                    <v-col>
                        <v-card>
                            <v-simple-table>
                                <template v-slot:default>
                                <thead>
                                    <tr>
                                    <th class="text-left">Lote</th>
                                    <th class="text-left">Maxisaco</th>
                                    <th class="text-left">Peso</th>
                                    <th class="text-left">Fecha Elaboración</th>
                                    </tr>
                                </thead>
                                <tbody v-if="preembarque.jumbos">
                                    <tr v-for="j in preembarque.jumbos" :key="j.id">
                                        <td>{{ j.lote ? j.lote.nombre_lote : '' }}</td>
                                        <td>{{ j.nro_jumbo }}</td>
                                        <td>{{ j.peso }}</td>
                                        <td>{{ j.resultado_analisis ? formatFechita(j.resultado_analisis.fecha) : '' }}</td>
                                    </tr>
                                </tbody>
                                </template>
                            </v-simple-table>
                        </v-card>
                    </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        text
                        @click="abrir_modal = false"
                    >
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-card>
            <v-col cols="12" class="d-flex justify-center">
                <v-btn class="green darken-1" dark @click="crear_preembarque" >Crear Preembarque</v-btn>
            </v-col>
            <tabla-paginada class="filitas" @cargar="cargar($event)" @ver_detalle="ver_detalle($event)" @editar_preembarque="editar_preembarque($event)" @subir_archivo="subir_archivo($event)"></tabla-paginada>
        </v-card>
        <modal-archivo></modal-archivo>
    </div>
</template>
<script>
import {mapState,mapMutations} from 'vuex';
import TablaPaginada from '@/components/shared/TablaPaginada.vue';
import ModalAyudas from '@/components/shared/ModalAyudas.vue';
import moment from 'moment'
// Modal Archivo
import ModalArchivo from '@/components/shared/Modal_Archivo.vue';

export default {
    data:()=>({
        abrir_modal:false,
        lista:[],
        preembarques:[],
        clientes:[],
        bodegas:[],
        proviene_de:[],
        can_download: true,
        inputs:[],
        configuracion_modal:{
            titulo_modal:'',
            boton_submit:'',
            ruta:'',
            tipo_peticion:'',
            motivos_repaso:[]
        },
        preembarque:[],
        columnas:[
            {nombre:'N°', width:'5%', align:'center', tipo:'numero', path:'id', key:'id', searchable:true, busqueda:''},
            {nombre:'Bodega origen', width:'13%', align:'center',tipo: 'select',path: 'bodegas.nombre',key:'bodegas_id',searchable:true,busqueda:'',opciones:[],valor_opcion:'id',texto_opcion:'nombre'},
            {nombre:'Fecha', width:'12%', align: 'center',tipo: 'date',opciones:[],path: 'fecha',key:'fecha',searchable:true,busqueda:''},
            {nombre:'Preembarque', width:'20%', align:'center',tipo: 'texto',path: 'nombre',key:'nombre',searchable:true,busqueda:''},
            {nombre:'Cliente', width:'20%', align:'center',tipo: 'select',path: 'clientes.nombre',key:'clientes_id',searchable:true,busqueda:'',opciones:[],valor_opcion:'id',texto_opcion:'nombre'},
            {nombre:'Observaciones', width:'20%', align:'center',tipo: 'texto',path: 'observaciones',key:'observaciones',searchable:true,busqueda:''},
            {nombre:'Detalle', width:'5%',key:'detalle',tipo:'evento',color:'#1565C0',icono:'zoom_in',evento:'ver_detalle',searchable:false},
            {nombre:'Archivo', width:'5%',key:'archivo',tipo:'evento',color:'blue',icono:'attach_file',evento:'subir_archivo',searchable:false},
            {nombre:'Editar', width:'5%',key:'editar',tipo:'evento',color:'#15C065',icono:'edit',evento:'editar_preembarque',searchable:false},
        ],
        acciones:[
        ]
    }),
    created() {
    },
    beforeDestroy() {
        Event.$off('actualizar_tabla');
    },
    mounted() {
        this.cargarClientes();
        this.cargarBodegas();
        this.cargar('');
    },
    methods: {
        abrirAyudas(){
            let jiji = [
                        {   titulo:`Ayuda de Listado de Preembarques`,    tipo:`titulo`},
                        {   tipo:`label`,   texto:`En esta pantalla se muestra el listado de Preembarques que se han registrado en el sistema de producción. Las columnas que se muestran son:`},
                        {   tipo:`label`,   texto:`- Número del Preembarque, Bodega origen, Fecha, Nombre, Cliente y Observaciones`},
                        {   tipo:`label`,   texto:`- Detalle : Al hacer click en la lupita de cada fila, se muestra el detalle del preembarque (lotes y maxisacos asociados ) con la opción de exportarlo a Excel. También se puede eliminar un maxisaco desde esa pantalla de detalle `},
                        {   tipo:`label`,   texto:`- Editar : Al hacer click en el botón de editar de cada fila, se abre una pantalla para poder modificar el preembarque `},
                        {   tipo:`imgtexto`,  url:`help-lista-movs.png`, ratio:'7.4', cols:'3', texto:`Bajo la fila de títulos tenemos la opción de filtrar información, o realizar búsquedas por número de preembarque, fecha, bodega, cliente u observación.`},
                        {   tipo:`imgtexto`,  url:`help-paginacion.png`, ratio:'7.4', cols:'1', texto:`- Finalmente, en la parte inferior de la pantalla se encuentra la paginación para ir a los registros mas antiguos o más recientes (hacer clic en los números)... `},

                    ]
            
            Event.$emit('mostrar_alert',jiji);
        },
        async cargarClientes(){
            this.mostrarLoading({titulo:'Cargando Clientes...',color:'green'})
            let url = `${this.base_url}clientes`;
            await this.axios.get(url,this.headers).then((response)=>{
                this.clientes = response.data.data;
                this.columnas[4].opciones = this.clientes;
            }).catch((error)=>{
                this.errorMessage(error, "Error al cargar Clientes..");
            });
            this.ocultarLoading();

        },
        async cargarBodegas(){
            this.mostrarLoading({titulo:'Cargando Bodegas...',color:'green'})
            let url = `${this.base_url}get_bodegas`;
            this.axios.get(url,this.headers).then((res)=>{
                this.bodegas = res.data.data;
                this.columnas[1].opciones = this.bodegas;
            }).catch((error)=>{
                this.errorMessage(error, "Error al cargar Bodegas..");
            });
            this.ocultarLoading();
        },
        async cargar(query){
            await this.axios.get(`${this.base_url}preembarques${query}`,this.headers).then((res)=>{
                this.lista = res.data.data.data;
                this.actualizarTablaPaginada({columnas:this.columnas,lista:this.lista,total_paginas:res.data.data.last_page});
                this.actualizarLista({lista:this.lista,total_paginas:res.data.data.last_page});
            }).catch((e)=>{
                this.errorMessage(e, "Error al cargar Preembarques..");
            })
        },
        detalle($event){
            console.log($event);
            this.$router.push({name:'preembarques_detalle',params:{id:$event.item.id}});
        },
        crear_preembarque() {
            this.$router.push({ name: 'crear_preembarques' });
        },
        editar_preembarque($event){
            console.log($event);
            this.$router.push({name:'editar_preembarque',params:{id:$event.item.id}});
        },
        subir_archivo({ item }){
            const config = {
                view: "preembarque",
                info_cargar: {
                    cargar: false,
                    url: item.url_archivo,
                },
                info_subir: {
                    url: `${this.base_url}preembarque/subir_archivo/${item.id}`,
                },
                info_descargar: {
                    url: `${this.base_url}preembarque/descargar_archivo/${item.id}`,
                    path: 'preembarques',
                },
                info_eliminar: {
                    url: `${this.base_url}preembarque/eliminar_archivo/${item.id}`,
                    confirm_message: `¿Desea eliminar el archivo de asignación de embarque con ID: ${item.id}, y preembarque: ${item.nombre}?`,
                }
            }
            this.$emit("abrir_modal_archivo", item, config);
        },
        async editar($event){
            console.log('editando',$event);
            this.configuracion_modal.titulo_modal = 'Editar Preembarque';
            this.configuracion_modal.titulo_boton = 'Actualizar';
            this.configuracion_modal.accion = 'editar';
            Event.$emit('abrir_modal_preembarque',$event.item,this.configuracion_modal);
        },
        async download(data){
            await this.axios.get(`${this.base_url}preembarques_a_excel/${data.id}`, this.headers).then((res)=>{
                window.location.href = this.download_url.replace('bitacoras', 'preembarques') + res.data;
            }).catch((e)=>{
                console.log(e);
            })
        },
        ver_detalle($event){
            console.log('jumbos', $event.item.jumbos);
            this.abrir_modal = true
            this.preembarque = $event.item
        },
        formatFechita(value) {
            if (value) {
                return moment(String(value)).format('DD-MM-YYYY')
            }
        },
        ...mapMutations(['mostrarLoading','ocultarLoading','actualizarTablaPaginada','actualizarLista'])
    },
    computed: {
        lotesSalientes(){
            /**retorna el id y nombre de los lotes distintos */
            let lotes = Array.from( new Set(this.preembarque.jumbos.map(j=>j.lotes_id)))
                    .map(id => {
                        return{
                            id:id,
                            todos:true,
                            nombre_lote: this.lotes.find(l => l.id === id).nombre_lote,
                            jumbos: this.jumbos_preembarque.filter(j => j.lotes_id == id).map(
                                j => {
                                    return {
                                        id:j.id,
                                        nro_jumbo:j.nro_jumbo,
                                        lotes_id:j.lotes_id,
                                        peso:j.peso,
                                        fecha_elab:j.fecha_elab,
                                        switch:j.switch,
                                    }
                                }
                            ).sort((a,b)=>a.nro_jumbo - b.nro_jumbo)
                        }
                    });
            return lotes;
        },
        ...mapState(['base_url', 'headers', 'download_url'])
    },
    components:{
        'tabla-paginada': TablaPaginada,
        'modal-ayuda': ModalAyudas,
        'modal-archivo': ModalArchivo
    }
}
</script>
<style scoped>
    .filitas > td{
        padding: 0.2em 1em;
        border-top: 1px solid #ccc;
    }
    .filitas { 
        border-spacing: 0;
        border-collapse:inherit ;
        border:1px solid #ccc;
    }
</style>